import React from 'react'; 
import { useEffect, useRef, useState } from 'react';
import WithConsumer from '../../context/WithConsumer';
import { Link } from 'react-router-dom';
import Image from '../global/Image';
import Footer from '../global/Footer';
import GravityForm from "react-gravity-form";
import TextareaAutosize from 'react-textarea-autosize';

const ProjectTemplate = ({ context }) => {
	
	let results = '';

		 
    const posts = () => context.posts;
    const post = posts()[0];
	
	const ctxPageLoaded = () => context.pageLoaded;
    const pageLoaded = ctxPageLoaded();
    
    const ctxPageLoadDone = () => context.pageLoadDone;
    const pageLoadDone = ctxPageLoadDone();
    
    const [boxHeight, setBoxHeight] = useState(0);
    const [boxOffset, setBoxOffset] = useState(0);
    
    const formPanelRef = useRef(null);
		
	useEffect(() => {
				
		window.addEventListener('resize', onResize);
		
		const interval = setInterval(() => {
            onResize()
        }, 500);
        
		return () => {
			window.removeEventListener('resize', onResize);
			clearInterval(interval);
		}
        
	}, []);
    
    function submitSuccess() {
	    //this.setState({ submitted : true });
	    if (post.form_redirect) {
			window.location = post.form_redirect;
		}
    }
    
    function onResize() {
	    if (formPanelRef) {
		    setBoxHeight(formPanelRef.current.clientHeight);
		    setBoxOffset(formPanelRef.current.offsetTop);
	    }
    }
    
    function scrollToForm() {
		if (formPanelRef) {
			console.log('boxOffset: ' + boxOffset);
		     if (boxOffset < (window.innerHeight * 0.5)) {
			 	window.scroll({
					behavior: 'smooth',
					left: 0,
					top: 0
				});
		     } else {
			     window.scroll({
					behavior: 'smooth',
					left: 0,
					top: (boxOffset + document.getElementsByClassName('c-header__bottom')[0].clientHeight + 1)
				});
		     }
		}
    }
    
    if (post) {
	    
	    if (boxHeight === 0) {
		    setTimeout(() => {
				onResize();
			}, 0);
	    }
	    
		let css = [];
		
		if (post.font_import) {
			
			if (post.heading_css_rules) {
				css.push(
					`.c-pro-template__heading, .scope-project-template-form h1, .scope-project-template-form h2, .scope-project-template-form h3, .scope-project-template-form h4, .scope-project-template-form h5, .scope-project-template-form h6, .scope-pro-template-text h1, .scope-pro-template-text h2, .scope-pro-template-text h3, .scope-pro-template-text h4, .scope-pro-template-text h5, .scope-pro-template-text h6 {${post.heading_css_rules}}`
				)
			}
			
			if (post.body_css_rules) {
				css.push(
					`.c-pro-template__text, .scope-pro-template-text *, .scope-project-template-form * {${post.body_css_rules}}`
				)
			}
			
			if (post.numerals_css_rules) {
				css.push(
					`.c-pro-template__numerals, .scope-project-template-form .footer button {${post.numerals_css_rules}}`
				)
			}
			
		} else {
	   
			if (post.heading_font_file) {
				if (post.heading_font_file.indexOf('.ttf') !== -1) {
					css.push(
						`@font-face{font-family:"Heading Font"; src:url("${post.heading_font_file}") format("truetype"); font-weight:400;}`
					);
				} else if (post.heading_font_file.indexOf('.otf') !== -1) {
					css.push(
						`@font-face{font-family:"Heading Font"; src:url("${post.heading_font_file}") format("opentype"); font-weight:400;}`
					);
				} else if (post.heading_font_file.indexOf('.woff2') !== -1) {
					css.push(
						`@font-face{font-family:"Heading Font"; src:url("${post.heading_font_file}") format("woff2"); font-weight:400;}`
					);
				} else if (post.heading_font_file.indexOf('.woff') !== -1) {
					css.push(
						`@font-face{font-family:"Heading Font"; src:url("${post.heading_font_file}") format("woff"); font-weight:400;}`
					);
				}
				css.push(
					`.c-pro-template__heading, .scope-project-template-form h1, .scope-project-template-form h2, .scope-project-template-form h3, .scope-project-template-form h4, .scope-project-template-form h5, .scope-project-template-form h6 {font-family:"Heading Font", serif}`
				)
			}
			
			if (post.body_font_file) {
				if (post.body_font_file.indexOf('.ttf') !== -1) {
					css.push(
						`@font-face{font-family:"Body Font"; src:url("${post.body_font_file}") format("truetype"); font-weight:400;}`
					);
				} else if (post.body_font_file.indexOf('.otf') !== -1) {
					css.push(
						`@font-face{font-family:"Body Font"; src:url("${post.body_font_file}") format("opentype"); font-weight:400;}`
					);
				} else if (post.body_font_file.indexOf('.woff2') !== -1) {
					css.push(
						`@font-face{font-family:"Body Font"; src:url("${post.body_font_file}") format("woff2"); font-weight:400;}`
					);
				} else if (post.body_font_file.indexOf('.woff') !== -1) {
					css.push(
						`@font-face{font-family:"Body Font"; src:url("${post.body_font_file}") format("woff"); font-weight:400;}`
					);
				}
				css.push(
					`.c-pro-template__text, .scope-pro-template-text *, .scope-project-template-form * {font-family:"Body Font", serif}`
				)
			}
			
			if (post.numerals_font_file) {
				if (post.numerals_font_file.indexOf('.ttf') !== -1) {
					css.push(
						`@font-face{font-family:"Numerals Font"; src:url("${post.numerals_font_file}") format("truetype"); font-weight:400;}`
					);
				} else if (post.body_font_file.indexOf('.otf') !== -1) {
					css.push(
						`@font-face{font-family:"Numerals Font"; src:url("${post.numerals_font_file}") format("opentype"); font-weight:400;}`
					);
				} else if (post.body_font_file.indexOf('.woff2') !== -1) {
					css.push(
						`@font-face{font-family:"Numerals Font"; src:url("${post.numerals_font_file}") format("woff2"); font-weight:400;}`
					);
				} else if (post.body_font_file.indexOf('.woff') !== -1) {
					css.push(
						`@font-face{font-family:"Numerals Font"; src:url("${post.numerals_font_file}") format("woff"); font-weight:400;}`
					);
				}
				css.push(
					`.c-pro-template__numerals, .scope-project-template-form .footer button {font-family:"Numerals Font", serif}`
				)
			}
			
		}
		
		if (post.mobile_logo_width && post.desktop_logo_width) {
			css.push(
				`.c-pro-template__logo{width:${post.mobile_logo_width / 16}rem;}@media screen and (min-width:47.5em){.c-pro-template__logo{width:${post.desktop_logo_width / 16}rem;}}`
			)
		}
		
		if (post.type_colour) {
			css.push(
				`.c-pro-template h1, .c-pro-template h2, .c-pro-template h3, .c-pro-template h4, .c-pro-template h5, .c-pro-template h6, .c-pro-template p, .c-pro-template ul, .c-pro-template ol {color:${post.type_colour};}`
			)
		} else {
			css.push(
				`.c-pro-template{background-color:#fff;}`
			)
		}
		
		if (post.button_border_color) {
			css.push(
				`.c-pro-template__card__button {border-color:${post.button_border_color};}`
			)
		} else {
			css.push(
				`.c-pro-template__card__button {border-color:#000;}`
			)
		}
		
		if (post.button_border_color) {
			css.push(
				`.c-pro-template__card__button {border-color:${post.button_border_color};}`
			)
		} else {
			css.push(
				`.c-pro-template__card__button {border-color:#000;}`
			)
		}
		
		if (post.button_background_color) {
			css.push(
				`.c-pro-template__card__button {background-color:${post.button_background_color};}`
			)
		} else {
			css.push(
				`.c-pro-template__card__button {background-color:#fff;}`
			)
		}
		
		if (post.button_type_color) {
			css.push(
				`.c-pro-template__card__button {color:${post.button_type_color};}`
			)
		} else {
			css.push(
				`.c-pro-template__card__button {color:#000;}`
			)
		}
		
		if (post.form_background_colour) {
			css.push(
				`.c-pro-template__form {background-color:${post.form_background_colour};}`
			)
		} else {
			css.push(
				`.c-pro-template__form {background-color:#FFF;}`
			)
		}
		
		if (post.form_text_colour) {
			css.push(
				`.c-pro-template__form *, .c-pro-template__form ::placeholder, body .scope-project-template-form .form-field .select .form-select > div:first-of-type {color:${post.form_text_colour} !important;border-color:${post.form_text_colour} !important;}.scope-project-template-form .form-field .select .form-select > div:first-of-type svg * {fill:${post.form_text_colour} !important;}`
			)
		} else {
			css.push(
				`.c-pro-template__form *, .c-pro-template__form ::placeholder, body .scope-project-template-form .form-field .select .form-select > div:first-of-type {color:black !important;border-color:yellow !important;}.scope-project-template-form .form-field .select .form-select > div:first-of-type svg * {fill:black !important;}`
			)
		}
		
		if (post.form_button_text_colour) {
			css.push(
				`.scope-project-template-form .footer button {color:${post.form_button_text_colour} !important;}`
			)
		} else {
			css.push(
				`.scope-project-template-form .footer button {color:black !important;}`
			)
		}
		
		if (post.form_button_border_colour) {
			css.push(
				`.scope-project-template-form .footer button {border-color:${post.form_button_border_colour} !important;}`
			)
		} else {
			css.push(
				`.scope-project-template-form .footer button {border-color:black !important;}`
			)
		}
		
		if (post.form_button_background_colour) {
			css.push(
				`.scope-project-template-form .footer button {background-color:${post.form_button_background_colour} !important;}`
			)
		} else {
			css.push(
				`.scope-project-template-form .footer button {background-color:white !important;}`
			)
		}
		
		if (post.card_background_color) {
			css.push(
				`.c-pro-template__card__inner {background-color:${post.card_background_color};}`
			)
		} else {
			css.push(
				`.c-pro-template__card__inner {background-color:white;}`
			)
		}
		
		if (post.card_type_color) {
			css.push(
				`body .c-pro-template__card__inner * {color:${post.card_type_color};fill:${post.card_type_color} !important;}`
			)
		} else {
			css.push(
				`body .c-pro-template__card__inner * {color:black;fill:black !important;}`
			)
		}
		
		if (post.card_button_border_color) {
			css.push(
				`body .c-pro-template__card__inner .c-pro-template__card__button {border-color:${post.card_button_border_color};}`
			)
		} else {
			css.push(
				`body .c-pro-template__card__inner .c-pro-template__card__button {border-color:black;}`
			)
		}
		
		if (post.card_button_background_color) {
			css.push(
				`body .c-pro-template__card__inner .c-pro-template__card__button {background-color:${post.card_button_background_color};}`
			)
		} else {
			css.push(
				`body .c-pro-template__card__inner .c-pro-template__card__button {background-color:white;}`
			)
		}
		
		if (post.card_button_text_color) {
			css.push(
				`body .c-pro-template__card__inner .c-pro-template__card__button {color:${post.card_button_text_color};}`
			)
		} else {
			css.push(
				`body .c-pro-template__card__inner .c-pro-template__card__button {color:black;}`
			)
		}
		
		if (post.cta_background_colour) {
			css.push(
				`.c-pro-template__cta {background-color:${post.cta_background_colour};}`
			)
		} else {
			css.push(
				`.c-pro-template__cta {background-color:white;}`
			)
		}
		
		if (post.cta_text_colour) {
			css.push(
				`body .c-pro-template__cta * {color:${post.cta_text_colour};border-color:${post.cta_text_colour} !important;}`
			)
		} else {
			css.push(
				`body .c-pro-template__cta * {color:black;border-color:black !important;}`
			)
		}
		
		let pageClass = 'c-page c-page--space c-page--' + post.slug;
		
		if (pageLoaded) {
		    pageClass = pageClass + ' state-page-loaded';
		}
			    	        							
		if (context.appError){
		
			return null; 
		
		} else {
			
			return (
				
				<div className={pageClass}>
					
					{post.font_import &&
						<div dangerouslySetInnerHTML={{__html:post.font_import}}></div>
					}
					<style>
						{css}
					</style>
											    					    			    		
		    		<div id="project-template" className="c-pro-template">
		    		
		    			<div className="c-pro-template__splash">
		    			
		    				<div className="c-pro-template__splash__inner">
		    				
			    				{post.landscape_splash_src && post.portrait_splash_src &&
			    					
			    					<>
			    					
			    						<div className="c-pro-template__splash__landscape">
											<Image srcset={post.landscape_splash_srcset} src={post.landscape_splash_src} />
										</div>
										
										<div className="c-pro-template__splash__portrait">
											<Image srcset={post.portrait_splash_srcset} src={post.portrait_splash_src} />
										</div>
										
									</>
			    				
			    				}
			    				
			    				{post.landscape_splash_src && !post.portrait_splash_src &&
			    										    					
		    						<div className="c-pro-template__splash__media">
										<Image srcset={post.landscape_splash_srcset} src={post.landscape_splash_src} />
									</div>
															    				
			    				}
			    				
			    				{!post.landscape_splash_src && post.portrait_splash_src &&
			    										    					
		    						<div className="c-pro-template__splash__media">
										<Image srcset={post.portrait_splash_srcset} src={post.portrait_splash_src} />
									</div>
															    				
			    				}
			    				
			    				<div className="c-pro-template__splash__overlay" style={{opacity:(post.overlay_opacity / 100)}}></div>
			    				
			    				{post.project_logo &&
				    				<div className="c-pro-template__logo">
										<img src={post.project_logo} alt={post.title} />
									</div>
			    				}
				    				
			    				<div className="c-pro-template__splash__elements" style={{top:boxOffset + 'px',minHeight: boxHeight + 'px'}}>
				    				
				    				<div></div>
				    				<div className="c-pro-template__splash__elements__space"></div>
				    				{post.heading &&
					    				<h1 className="c-pro-template__main-heading c-pro-template__heading" dangerouslySetInnerHTML={{__html:post.heading}}></h1>
				    				}
				    			</div>
				    			
				    		</div>
				    		
				    		{post.form_id &&
				    			<div className="c-pro-template__form scope-project-template-form" ref={formPanelRef}>
					    			<GravityForm
										backendUrl={document.location.origin + '/wp-json/sivasli/v1/form'}
										formID={post.form_id}
										onSubmitSuccess={submitSuccess}
									/>
								</div>
			    			}
		    				
		    			</div>
		    			
		    			{post.cta_left_column && post.cta_right_column &&
			    			
			    			<div className="c-pro-template__cta">
			    				<div className="c-pro-template__cta__wrap">
				    				<div className="c-pro-template__cta__inner">
				    					{post.cta_left_column &&
					    					<div className="c-pro-template__cta__column">
					    						<div className="scope-cta-text scope-pro-template-text" dangerouslySetInnerHTML={{__html:post.cta_left_column}}></div>
					    					</div>
				    					}
				    					{post.cta_right_column &&
					    					<div className="c-pro-template__cta__column">
					    						<div className="scope-cta-text scope-pro-template-text" dangerouslySetInnerHTML={{__html:post.cta_right_column}}></div>
					    					</div>
				    					}
				    				</div>
				    			</div>
			    			</div>
			    			
		    			}
		    			
		    			
		    			{post.property &&
			    			
			    			<div className="c-pro-template__cards" style={{backgroundColor:post.background_colour}}>
			    			
			    				<div className="c-pro-template__cards__inner" >
							
									{post.property.map((card,i) =>
										{	
											return (
												<div className="c-pro-template__card">
													<div className="c-pro-template__card__inner">
														
														{card.src &&
															<Image width={1920} height={1080} srcset={card.srcset} src={card.src} />
														}
													
														{card.heading &&
															<h3 className="c-pro-template__card__heading c-pro-template__heading" dangerouslySetInnerHTML={{__html:card.heading}}></h3>
														}
														<div className="c-pro-template__card__icons">
															{card.bedrooms &&
																<div className="c-pro-template__card__icons__icon c-pro-template__card__icons__icon--beds c-pro-template__numerals" dangerouslySetInnerHTML={{__html:"<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 30 30' style='enable-background:new 0 0 30 30;' xml:space='preserve'><path d='M24.8,17.66H5.2c-0.56,0-0.56,0.28-0.56,0.56s0.28,0.56,0.56,0.56h19.6c0.28,0,0.56-0.28,0.56-0.56S25.08,17.66,24.8,17.66z M27.6,4.5H2.12C1,4.5,0.16,5.34,0.16,6.46v18.48c0,0.28,0.28,0.56,0.56,0.56h3.36c0.28,0,0.56-0.28,0.56-0.56v-2.8h20.72v2.8 c0,0.28,0,0.56,0.56,0.56h3.36c0.28,0,0.56-0.28,0.56-0.56V6.46C29.56,5.34,28.72,4.5,27.6,4.5z M28.44,24.38H26.2v-2.8 c0-0.28-0.28-0.56-0.56-0.56H4.08c-0.28,0-0.56,0.28-0.56,0.56v2.8H1.28v-8.96c0-0.56,0.28-0.84,0.84-0.84h25.76 c0.56,0,0.84,0.28,0.84,0.84L28.44,24.38z M4.64,13.46v-2.52c0-0.56,0.28-0.84,0.84-0.84h5.88c0.56,0,0.84,0.28,0.84,0.84v2.52H4.64 z M17.52,13.46v-2.52c0-0.56,0.28-0.84,0.84-0.84h5.88c0.56,0,1.12,0.56,1.12,0.84v2.52H17.52z M28.72,13.74 c-0.28,0-0.56-0.28-0.84-0.28H26.2v-2.52c0-1.12-0.84-1.96-1.96-1.96h-5.88c-1.12,0-1.96,0.84-1.96,1.96v2.52h-3.08v-2.52 c0-1.12-0.84-1.96-1.96-1.96H5.48c-1.12,0-1.96,0.84-1.96,1.96v2.52h-1.4c-0.28,0-0.56,0-0.84,0.28V6.46c0-0.56,0.28-0.84,0.84-0.84 h25.76c0.56,0,0.84,0.28,0.84,0.84V13.74z'/></svg>" + card.bedrooms}}></div>
															}
															{card.bathrooms &&
																<div className="c-pro-template__card__icons__icon c-pro-template__card__icons__icon--baths c-pro-template__numerals" dangerouslySetInnerHTML={{__html:"<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 30 30' style='enable-background:new 0 0 30 30;' xml:space='preserve'><path d='M29.17,17.67H4.49V4c0-0.33,0.33-1,0.33-1c0.67-0.67,1.33-0.67,2-0.33C5.5,4,5.5,6,6.5,7h0.33h0.33l4.67-4.67V1.99V1.66 C11.17,0.99,10.5,0.99,9.5,0.99c-0.67,0-1.33,0.33-2,1c-1-0.67-2.67-0.67-3.67,0.33C3.16,3,3.16,3.66,3.16,4.33V18H0.83 c-0.33,0-0.67,0.33-0.67,0.67c0,0.33,0.33,0.67,0.67,0.67h0.67l3,8.34c0,0.33,0.33,0.33,0.67,0.33h0.67v0.33 c0,0.33,0.33,0.67,0.67,0.67c0.33,0,0.33-0.67,0.33-0.67v-0.67h16.34v0.67c0,0.33,0.33,0.67,0.67,0.67c0.33,0,0.33-0.67,0.33-0.67 v-0.67h0.67c0.33,0,0.33,0,0.67-0.33l3-8.34h0.67c0.33,0,0.67-0.33,0.67-0.67C29.84,18,29.51,17.67,29.17,17.67z M8.16,3 c0.67-0.33,1.33-1,2-1h0.67L7.16,5.66C6.83,5,7.5,4,8.16,3z M24.5,26.67H5.5l-3-7.67h24.68L24.5,26.67z M9.83,7H9.16 c-0.33,0.33-0.33,0.67,0,0.67l0.67,0.67h0.33h0.33c0.33-0.33,0.33-0.67,0-0.67L9.83,7z M12.17,7.66h0.33h0.33 c0.33,0,0.33-0.67,0-0.67l-0.67-0.67C11.83,6,11.5,6,11.5,6.33C11.17,6.66,11.17,7,11.5,7L12.17,7.66z M12.83,5.33h0.33h0.33 c0.33-0.33,0.33-0.67,0-0.67L12.83,4c-0.33-0.33-0.67-0.33-0.67,0c-0.33,0-0.33,0.33,0,0.67L12.83,5.33z M11.5,10l0.67,0.67h0.33 h0.33c0.33-0.33,0.33-0.67,0-0.67l-0.67-0.67C11.83,9,11.5,9,11.5,9.33C11.17,9.66,11.17,10,11.5,10z M14.5,7l0.67,0.67h0.67 c0.33-0.33,0.33-0.67,0-0.67l-0.67-0.67C14.83,6,14.5,6,14.5,6.33C14.17,6.66,14.17,7,14.5,7z M14.5,8.33h-1v1L14.17,10h0.33h0.33 c0.33-0.33,0.33-0.67,0-0.67L14.5,8.33z'/></svg>" + card.bathrooms}}></div>
															}
															{card.carspots &&
																<div className="c-pro-template__card__icons__icon c-pro-template__card__icons__icon--cars c-pro-template__numerals" dangerouslySetInnerHTML={{__html:"<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 30 30' style='enable-background:new 0 0 30 30;' xml:space='preserve'><path d='M29.4,9.8L15.2,3.4h-0.6L0.4,9.8c-0.3,0-0.3,0.6-0.3,0.8C0.2,11,0.7,11,1,11l13.9-6.4L28.9,11h0.3c0.3,0,0.3,0,0.6-0.3 C30,10.4,29.7,10.1,29.4,9.8z M25,18.5h-1.7l-1.1-6.1c0-0.3-0.3-0.3-0.6-0.3H8.5c-0.3,0-0.6,0.3-0.6,0.6l-1.1,6.1H5.2 c-0.3,0-0.6,0.3-0.6,0.6v4.5c0,0.3,0.3,0.6,0.6,0.6h1.7V26c0,0.3,0.3,0.6,0.6,0.6h2.2c0.3,0,0.6-0.3,0.6-0.6v-2H20v1.7 c0,0.3,0.3,0.6,0.6,0.6h2.2c0.3,0,0.6-0.3,0.6-0.6v-1.7H25c0.3,0,0.6-0.3,0.6-0.6V19C25.5,18.8,25.3,18.5,25,18.5z M9.1,13.2h12 l0.8,5.3H8L9.1,13.2z M9.4,24.9H8.2v-0.8h1.1V24.9z M22.2,24.9h-1.1v-0.8h1.1V24.9z M24.4,22.9H6v-3.3h18.4V22.9z M12.2,21.8h6.4 c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6h-6.4c-0.3,0-0.6,0.3-0.6,0.6C11.6,21.6,11.9,21.8,12.2,21.8z M7.7,21.8h1.1 c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6H7.7c-0.3,0-0.6,0.3-0.6,0.6C7.1,21.6,7.4,21.8,7.7,21.8z M21.6,21.8h1.1 c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6h-1.1c-0.3,0-0.6,0.3-0.6,0.6C21.1,21.6,21.4,21.8,21.6,21.8z'/></svg>" + card.carspots}}></div>
															}
														</div>
														{card.price &&
															<div className="c-pro-template__card__price">
																<p className="c-pro-template__card__price__text c-pro-template__numerals" dangerouslySetInnerHTML={{__html:card.price}}></p>
															</div>
														}
														{card.btn_text && card.btn_url && card.btn_type == 'url' &&
															<div className="c-pro-template__card__buttons">
																<a className="c-pro-template__card__button c-pro-template__numerals" href={card.btn_url} target="_blank" dangerouslySetInnerHTML={{__html:card.btn_text}}></a>
															</div>
														}
														{card.btn_text && card.btn_email && card.btn_subject && card.btn_type == 'email' &&
															<div className="c-pro-template__card__buttons">
																<a className="c-pro-template__card__button c-pro-template__numerals" href={'mailto:' + card.btn_email + '?subject=' + card.btn_subject} target="_blank" dangerouslySetInnerHTML={{__html:card.btn_text}}></a>
															</div>
														}
														{card.btn_text && card.btn_phone && card.btn_type == 'phone' &&
															<div className="c-pro-template__card__buttons">
																<a className="c-pro-template__card__button c-pro-template__numerals" href={'tel:+' + card.btn_phone} dangerouslySetInnerHTML={{__html:card.btn_text}}></a>
															</div>
														}
														{card.btn_text && card.btn_type == 'form' &&
															<div className="c-pro-template__card__buttons">
																<div className="c-pro-template__card__button c-pro-template__numerals" dangerouslySetInnerHTML={{__html:card.btn_text}} onClick={scrollToForm}></div>
															</div>
														}
													</div>
												</div>
											)
										}
									)}
							
								</div>
							
							</div>
						
						}
						
						{post.info &&
							
							<div className="c-pro-template__info">
			    										
								{post.info.map((block,i) =>
									{	
										return (
											<div className={'c-pro-template__block c-pro-template__block--' + block.alignment}>
												<div className="c-pro-template__block__image">
													{block.src && 
														<Image width={block.img_width} height={block.img_height} srcset={block.srcset} src={block.src} />
													}
												</div>
												<div className="c-pro-template__block__text">
													
													<div className="c-pro-template__block__text__top">
														{block.heading &&
															<h3 className="c-pro-template__block__heading c-pro-template__heading" dangerouslySetInnerHTML={{__html:block.heading}}></h3>
														}
														{block.text &&
															<div className="c-pro-template__block__heading scope-pro-template-text" dangerouslySetInnerHTML={{__html:block.text}}></div>
														}
													</div>
													
													{block.btn_text && block.btn_url && block.btn_type == 'url' &&
														<div className="c-pro-template__block__text__bottom">
															<a className="c-pro-template__card__button c-pro-template__numerals" href={block.btn_url} target="_blank" dangerouslySetInnerHTML={{__html:block.btn_text}}></a>
														</div>
													}
													{block.btn_text && block.btn_email && block.btn_subject && block.btn_type == 'email' &&
														<div className="c-pro-template__block__text__bottom">
															<a className="c-pro-template__card__button c-pro-template__numerals" href={'mailto:' + block.btn_email + '?subject=' + block.btn_subject} target="_blank" dangerouslySetInnerHTML={{__html:block.btn_text}}></a>
														</div>
													}
													{block.btn_text && block.btn_phone && block.btn_type == 'phone' &&
														<div className="c-pro-template__block__text__bottom">
															<a className="c-pro-template__card__button c-pro-template__numerals" href={'tel:+' + block.btn_phone} dangerouslySetInnerHTML={{__html:block.btn_text}}></a>
														</div>
													}
													{block.btn_text && block.btn_type == 'form' &&
														<div className="c-pro-template__block__text__bottom">
															<div className="c-pro-template__card__button c-pro-template__numerals" dangerouslySetInnerHTML={{__html:block.btn_text}} onClick={scrollToForm}></div>
														</div>
													}
												</div>
											</div>
										)
									}
								)}
														
							</div>
							
						}					
		    									    		
			    	</div>
			    	
			    	<Footer post={post}></Footer>
					
				</div>
				
				
														
			)
				
		}
		
	} else {
		
		return null;
	
	}
};
export default WithConsumer(ProjectTemplate);